import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAiAnno = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M17.3753 8V16.8936H15.5327V8H17.3753Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.99001 16.8936H6L9.08329 7.99997H11.4541L14.5251 16.8936H12.5474L11.884 14.8422H8.66563L7.99001 16.8936ZM9.13242 13.4049H11.4173L10.2994 10.0023H10.238L9.13242 13.4049Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.45 4.45L16.925 5.85L16.3995 4.45L15 3.925L16.3995 3.3995L16.925 2L17.45 3.3995L18.85 3.925L17.45 4.45ZM20.25 7.25001L19.55 9L18.85 7.25001L17.1 6.55L18.85 5.84999L19.55 4.1L20.25 5.84999L22 6.55L20.25 7.25001Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.25 18V15C2.25 14.5858 2.58579 14.25 3 14.25C3.38826 14.25 3.70784 14.545 3.74634 14.9231L3.75 15V18L3.75293 18.1157C3.81316 19.3046 4.79617 20.25 6 20.25H9L9.0769 20.2537C9.455 20.2922 9.75 20.6117 9.75 21C9.75 21.3883 9.455 21.7078 9.0769 21.7463L9 21.75H6C3.99354 21.75 2.3554 20.1742 2.25513 18.1926L2.25 18ZM20.25 18V15C20.25 14.5858 20.5858 14.25 21 14.25C21.4142 14.25 21.75 14.5858 21.75 15V18C21.75 20.0711 20.0711 21.75 18 21.75H15C14.5858 21.75 14.25 21.4142 14.25 21C14.25 20.5858 14.5858 20.25 15 20.25H18C19.2426 20.25 20.25 19.2426 20.25 18ZM2.25 9V6C2.25 3.92893 3.92893 2.25 6 2.25H9L9.0769 2.25366C9.455 2.29216 9.75 2.61174 9.75 3C9.75 3.38826 9.455 3.70784 9.0769 3.74634L9 3.75H6C4.75736 3.75 3.75 4.75736 3.75 6V9L3.74634 9.0769C3.70784 9.455 3.38826 9.75 3 9.75C2.61174 9.75 2.29216 9.455 2.25366 9.0769L2.25 9Z",
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgAiAnno);
export default ForwardRef;
